import React, {useEffect, useState} from 'react'
import DHDialog from "../../general/DHDialog";
import ErrorInfoComponent from "../../general/ErrorInfoComponent";
import ConfigUtil from "../../../util/ConfigUtil";
import FetchUtil from "../../../util/FetchUtil";
import DHTextFieldSmall from "../../general/DHTextFieldSmall";
import DHButtonSave from "../../general/DHButtonSave";
import ConfirmDialog from "../../general/ConfirmDialog";

export default function LigaMannschaftZugangDialog({mannschaft, onRefresh, onClose}) {

    const [infoMessage, setInfoMessage] = useState(undefined);
    const [errorMessage, setErrorMessage] = useState(undefined);

    const [showGenerateAccountDialog, setShowGenerateAccountDialog] = useState(false);

    const [idShort, setIdShort] = useState("");

    useEffect(() => {
        setIdShort(mannschaft.eventOperatorIdShort ? mannschaft.eventOperatorIdShort : "");
    }, [mannschaft]);

    const generateAccount = () => {
        setErrorMessage("Diese Aktion ist noch nicht implementiert.... TODO");
        setShowGenerateAccountDialog(false);
    }

    const saveById = () => {
        setErrorMessage(undefined);
        let url = ConfigUtil.getConfig().resourceUrls.league + "/mannschaft/verknuepfung/veranstalter/" + mannschaft.id;
        FetchUtil.fetchPost(url,
            {value:idShort !== "" ? idShort : null},
            message => {
                if( message ) {
                    setErrorMessage(message);
                } else {
                    onRefresh();
                    setInfoMessage("Erfolgreich gespeichert.");
                }
            },
            responseNotOk => {
                setErrorMessage("Fehler: " + responseNotOk.message);
            },
            error => {
                setErrorMessage("Fehler: " + error.message)
            });
    }

    const getDataArea = () => {
        return <div style={{padding: 20}}>
            <ErrorInfoComponent infoMessage={infoMessage} errorMessage={errorMessage} onClearInfoMessage={() => setInfoMessage(undefined)}
                                onClearErrorMessage={() => setErrorMessage(undefined)}/>
            {!mannschaft.eventOperatorIdShort && <div style={{paddingTop: 20}}>
                Die Mannschaft hat aktuell keinen Login/Zugang zu Darthelfer!
            </div>
            }
            <div style={{paddingTop: 20}}>
                Möglichkeit 1: Du kennst die Id eines bereits bestehenden Veranstalters in Darthelfer und gibst die ID des Veranstalters hier ein und speicherst diese.<br/>
                Die ID findet der Veranstalter nach dem Login auf seinem Dashboard.<br/>
                Du kannst damit ebenfalls eine bereits bestehende Mannschaft->Veranstalter Zuordnung ändern und eine neue ID speichern.<br/>
                <div style={{color: "red", marginTop: 10}}>Bitte beachte: der zugewiesene Veranstalter kann damit alle Änderungen rund um diese Mannschaft in Darthelfer durchführen.</div>
                <div style={{marginTop: 10}}>
                    <DHTextFieldSmall id="id-idshort" onChange={(text) => setIdShort(text)} value={idShort} width={300} label="Veranstalter-Id"/>
                </div>
                <div style={{marginTop: 10}}>
                    <DHButtonSave label={"Speichern"} working={false} onClick={() => saveById()}/>
                </div>
            </div>
            <div style={{paddingTop: 20}}>
                Möglichkeit 2: Du legst einen neuen Veranstalter in Darthelfer an, der Kapitän der Mannschaft erhält Zugangsdaten. Der neue Veranstalter wird automatischer dieser Mannschaft
                zugewiesen.
                <div style={{marginTop: 10}}>
                    <DHButtonSave disabled={idShort !== ""} label={"Neuen Zugang anlegen, Zugangsdaten an Kapitän versenden"} working={false} onClick={() => setShowGenerateAccountDialog(true)}/>
                </div>

            </div>
            {showGenerateAccountDialog && <ConfirmDialog header="Zugang erzeugen..."
                                                         textOben="Sobald du den Zugang erzeugst, erhält der Mannschaftskapitän Zugangsdaten und die Mannschaft wird mit diesem neuen Account verknüpft."
                                                         textUnten="Möchtest du den Zugang wirklich erzeugen?"
                                                         callBackOnJa={() => generateAccount()}
                                                         callBackOnNein={() => setShowGenerateAccountDialog(false)}
                                                         visible={true}/>
            }
        </div>
    }
    return <DHDialog onClose={() => onClose()} title="Zugang für Mannschaft verwalten" showCloseButton={true} comp={<>{getDataArea()}</>}/>
}
